import { NewSubpatientFormActions } from './NewSubpatientFormActions';

function getErrorField(errors, field) {
    return errors.find(error => error.name === field);
}

export const defaultState = {
    creatingSubPatients: false,
    subpatientCreationSuccess: false,
    subpatientCreationFailure: false,
    emailErrorMessage: null,
    showErrorModal: false,
    nameErrorMessage: undefined,
    showDateError: false,
};

export const newSubpatientFormReducer = (state = defaultState, action) => {
    switch (action.type) {
        case NewSubpatientFormActions.RESET: {
            return defaultState;
        }

        case NewSubpatientFormActions.CREATING_SUBPATIENT: {
            return {
                ...state,
                creatingSubPatients: true,
                subpatientCreationSuccess: false,
                subpatientCreationFailure: false,
                emailErrorMessage: null,
                nameErrorMessage: null,
                showDateError: false,
            };
        }

        case NewSubpatientFormActions.SUBPATIENT_CREATION_SUCCESS: {
            return {
                ...state,
                creatingSubPatients: false,
                subpatientCreationSuccess: true,
                subpatientCreationFailure: false,
                subPatientFirstName: action.firstName,
                subPatientLastName: action.lastName,
                subPatientPatientId: action.patientId,
            };
        }

        case NewSubpatientFormActions.SUBPATIENT_CREATION_FAILURE: {
            if (action.errorFields === undefined) {
                return {
                    ...state,
                    creatingSubPatients: false,
                    subpatientCreationSuccess: false,
                    subpatientCreationFailure: true,
                    showErrorModal: true,
                };
            }

            const emailError = getErrorField(action.errorFields, 'email');
            const firstNameError = getErrorField(
                action.errorFields,
                'first_name'
            );
            const lastNameError = getErrorField(
                action.errorFields,
                'last_name'
            );
            const showDateError = !!getErrorField(action.errorFields, 'dob');

            let nameErrorMessage = firstNameError
                ? firstNameError.message
                : null;
            if (!nameErrorMessage) {
                nameErrorMessage = lastNameError ? lastNameError.message : null;
            }

            return {
                ...state,
                creatingSubPatients: false,
                subpatientCreationSuccess: false,
                subpatientCreationFailure: true,
                emailErrorMessage: emailError ? emailError.message : null,
                nameErrorMessage,
                showDateError,
            };
        }

        default:
            return state;
    }
};
